import React, { Component, Fragment } from "react";
import { Row, Card, CardTitle, Form, Label, Input, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
//import Paginator from 'react-hooks-paginator';
import { ToastProvider } from "react-toast-notifications";

import { loginUser } from "../redux/actions";
import { Colxx } from "../components/common/CustomBootstrap";
import { projectTitle } from "../constants/defaultValues";
import HomeHeader from "../components/common/HomeHeader";
import HomeFooter from "../components/common/HomeFooter";

import {REST_API_END_POINT,dataEncryptKey, BASE_URL } from "../constants/defaultValues";

import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";
import MailChimpIntegration from "../components/front-end/MailChimpIntegration";
import { seo } from "../helpers/Utils";

const dataCrypto = new SimpleCrypto(dataEncryptKey);

class BlogPost extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
		  template_data:null,
		  next_urls:{
			  prev:'',
			  next:''
		  }
		};
		this.dataListRender = this.dataListRender.bind(this);
		seo({
			title: 'Blog | '+projectTitle,
		});
	}
  
	componentDidMount() {
		
		document.body.classList.add("background");
		document.body.classList.add("background-main-pages");
		var facility_id = localStorage.getItem('facility_id');
		if(facility_id){
			this.dataListRender();
		}else{
			window.location='/';
		}
	}
	
	componentWillUnmount() {
		document.body.classList.remove("background");
		document.body.classList.remove("background-main-pages");
	}
	
	dataListRender() {
		var facility_id = localStorage.getItem('facility_id');
		facility_id =  dataCrypto.decrypt(facility_id);
		var data_upload = new FormData();
		data_upload.append('facility_id',facility_id);
		data_upload.append('alias_url',this.props.match.params.alias_url);
		axios.post(REST_API_END_POINT+'website/get-post-by-alias-url',data_upload).then((res)=>{ 
			if(res.data.status==1){
				this.setState({ template_data: res.data.data, next_urls:res.data.next_urls, blocking:false });				
			}else{
				window.location="/error";				
			}			
		}).catch(e =>{ 
			console.log("Addition failed , Error ", e)
			this.setState({ blocking:false });
		});
	}

	render() {
		
		const { template_data, next_urls } = this.state;
		var content_text='';
		var banner_image='';
		var page_name='';
		var page_sub_title='';
		if(template_data!=null){			
			page_name=template_data.name;
			content_text=template_data.content;
			banner_image=template_data.featured_image;
		}
		return (
			<Fragment>
				<ToastProvider placement="bottom-left">
					<div className="main-pages-layout">
						<main>
							<HomeHeader />
									<div className="p-4 mt-4 mb-4">
										{banner_image!='' && banner_image!=null ? <img src={`${BASE_URL}pages/${banner_image}`} className="img-responsive" />:""}
										<div className="front-page-header-wrapper d-flex flex-wrap-wrap align-items-center">
											<div className="front-page-header-text mt-3">
												<h1>{page_name}</h1>
											</div>
										</div>
										
										{content_text!='' ? <div className="row">
											<div className="col-lg-12">
												<div className="dynamic-page-content" dangerouslySetInnerHTML={{ __html: content_text }} ></div>
											</div>
										</div>:""}
										<div className="mt-2">
											{next_urls.prev!="" ? <a href={"/blog/"+next_urls.prev} className="btn btn-sm btn-black mr-2">Prev</a>:"" }
											{next_urls.next!="" ? <a href={"/blog/"+next_urls.next} className="btn btn-sm btn-black ">Next</a>:"" }
										</div>
									</div>
									
									
									{/*discount ends */}
										<MailChimpIntegration />
									{/*discount ends */}
							<HomeFooter />
						</main>	
					</div>
				</ToastProvider>
			</Fragment>	
		);
	}
}

const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    loginUser
  }
)(BlogPost);
